import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { take, tap } from 'rxjs';
import { matchPassword } from '@core/validators/match-password.validator';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { patternValidator, patternInvalidator } from '@core/validators/pattern.validator';
@Component({
    selector: 'app-create-password',
    templateUrl: './create-password.component.html',
    styleUrls: ['./create-password.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CreatePasswordComponent implements OnInit {
  createPwForm: FormGroup | any;
  resetFailed = false;
  hidden: boolean = true;
  confirmHidden: boolean = true;
  showPassword = false;
  showConfirmPassword = false;
  formSubmitted: boolean = false;

  faEye = faEye;
  faEyeSlash = faEyeSlash;

  guid: string = '';
  get f() {
    return this.createPwForm.controls;
  }
  get newPw() {
    return this.createPwForm.get('newPw');
  }
  get confirmPw() {
    return this.createPwForm.get('confirmPw');
  }

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private router: Router,
    private authService: AuthService
  ) {}
  ngOnInit(): void {
    this.guid = this.getGuidFromUrl();
    this.authService
      .isValidIdentifier(this.guid)
      .pipe(take(1))
      .subscribe((res) => {
        if (!res) {
          this.toastr.error('Link is invalid');
          this.router.navigateByUrl('login');
        }
      });
    this.createPwForm = this.fb.group(
      {
        newPw: [
          '',
          [
            Validators.required,
            Validators.minLength(8),
            patternValidator(/\d/, { 'Missing Number': false }),
            patternValidator(/[A-Z]/, { 'Missing Uppercase character': false }),
            patternValidator(/[a-z]/, { 'Missing Lowercase character': false }),
            patternValidator(/[!@#\[\]\$%\^\*`~\-\=()_,.:><\\\/?]/, {
              'Missing Special Character': false,
            }),
            patternInvalidator(/[\+\&]/, {
              'Invalid Special Characters Used: &/+': false,
            }),
          ],
        ],
        confirmPw: ['', [Validators.required]],
      },
      { validator: matchPassword('newPw', 'confirmPw') }
    );
  }

  handleSubmit(): void {

    if (this.createPwForm.invalid) {
      this.toastr.error('Please fix your form errors!');
      return;
    }

    this.formSubmitted = true;

    const payload = {
      passwordReset: this.confirmPw.value,
      guid: this.guid,
    };

    this.authService
      .createPassword(payload, 'Password has been created.')
      .pipe(take(1))
      .subscribe((res) => {
        this.resetFailed = false;
        if (typeof res === 'string') {
          this.resetFailed = true;
        }
      });
    this.createPwForm.reset();
    this.formSubmitted = false;
    setTimeout(() => {
      this.router.navigateByUrl('');
    }, 2000);
  }

  getGuidFromUrl(): string {
    const routerUrl = this.router.url;
    const indexOfSlash = routerUrl.lastIndexOf('/');
    return routerUrl.slice(indexOfSlash + 1);
  }

  togglePassword(type: string): void {
    if(type == 'password') this.showPassword = !this.showPassword;
    else this.showConfirmPassword = !this.showConfirmPassword;
  }
}
